export default __webpack_public_path__ + "7db9c155e981d86e92aa202b9abc28bb.png";